
















































































































	import {Component, Vue} from '@/shared/component';
	import {Stored} from "vue-stored-prop-decorator/index";
	import {Achat, Approvisionnement, Commande, User, Vente} from '@/models';
	import {Emit} from 'vue-property-decorator';

	import {Fournisseur, Client} from '@/models';
	import CrudFournisseurEditDialog from '@/components/Crud/Fournisseur/EditDialog.vue';
	import CrudClientEditDialog from '@/components/Crud/Client/EditDialog.vue';
	import CrudVenteEditDialog from "@/components/Crud/Vente/EditDialog.vue";
	
	import storeUser from '@/stores/modules/user';
	import storeFournisseur from "@/stores/modules/fournisseur";
	import storeClient from "@/stores/modules/client";
	import CrudAchatEditDialog from "@/components/Crud/Achat/EditDialog.vue";
	import CrudAchatEditLivraisonDialog from "@/components/Crud/Achat/EditLivraisonDialog.vue";
	import CrudApprovisionnementEditDialog from "@/components/Crud/Approvisionnement/EditDialog.vue";
	import CrudCommandeEditDialog from "@/components/Crud/Commande/EditDialog.vue";
	import { version } from '../../../package.json';


	@Component({
		components: {
			CrudFournisseurEditDialog,
			CrudClientEditDialog,
			CrudVenteEditDialog,
			CrudAchatEditDialog,
			CrudAchatEditLivraisonDialog,
			CrudApprovisionnementEditDialog,
			CrudCommandeEditDialog,
		}
	})

	export default class NavigationMainMenu extends Vue {

		@Stored(() => storeUser) me!: User;

		private reduce: boolean = false;
		private open: boolean = false;

		private items = [
			{
				route: { name: 'home' },
				title: 'Accueil',
				grant: 'NAV_HOME',
				icon: '$home',
			},
			{
				route: { name: 'planning' },
				title: 'Planning expédition',
				grant: 'NAV_VENTES',
				icon: '$calendar',
			},
			{
				route: { name: 'tableauAchats' },
				title: 'Tableau de bord coupes',
				grant: 'NAV_TABLEAU_BORD_ACHATS',
				icon: '$dashboard',
			},
			{
				route: { name: 'tableauVentes' },
				title: 'Tableau de bord expéditions',
				grant: 'NAV_TABLEAU_BORD_VENTES',
				icon: '$dashboard',
			},
			{
				title: 'Tiers',
				icon: '$fournisseur',
				grant: 'NAV_FOURNISSEUR',
				children: [
					{
						route: { name: 'fournisseurs' },
						title: 'Liste des fournisseurs',
						icon: '$fournisseurs',
						grant: 'API_GET_FOURNISSEURS',
					},
					{
						title: 'Créer un fournisseur',
						icon: '$new_fournisseur_client',
						grant: 'API_POST_FOURNISSEURS',
						clickparameter: 'Fournisseur',
					},
					{ divider: true, inset: true },
					{
						route: { name: 'clients' },
						title: 'Liste des clients',
						icon: '$clients',
						grant: 'API_GET_CLIENT',
					},
					{
						title: 'Créer un client',
						icon: '$new_fournisseur_client',
						grant: 'API_POST_CLIENT',
						clickparameter: 'Client',
					},
					{ divider: true, inset: true },
					{
						route: { name: 'contact' },
						title: 'Liste des contacts',
						icon: '$contacts',
						grant: 'API_GET_CONTACT',
					},
				]
			},
			{
				title: 'Gestion des coupes',
				icon: '$achats',
				grant: 'NAV_ACHATS',
				children: [
				{
					route: { name: 'achats' },
					title: 'Liste des coupes achetées',
					icon: '$achats_children',
					grant: 'API_GET_ACHAT',
				},
				{
					route: { name: 'achats-encours' },
					title: 'Coupes en cours',
					icon: '$achats_children',
					grant: 'API_GET_ACHAT',
				},
				{
					route: { name: 'MapAchats' },
					title: 'MAP des coupes',
					icon: 'mdi-map-marker-check-outline',
					grant: 'API_GET_ACHAT',
				},
				{
					route: { name: 'essenceAchats' },
					title: 'Essences achetées',
					icon: '$achats_children',
					grant: 'API_GET_ESSENCEACHAT',
				},
				{
					title: 'Créer une coupe',
					icon: '$new_achats',
					grant: 'API_POST_ACHAT',
					clickparameter: 'Achat',
				},
				{ divider: true, inset: true },
				{
					route: { name: 'livraisons' },
					title: 'Liste des livraisons',
					icon: '$livraisons',
					grant: 'API_GET_LIVRAISON',
				},
				{
					title: 'Créer une livraison',
					icon: '$livraisons',
					grant: 'API_POST_LIVRAISON',
					clickparameter: 'Livraison',
				},
				]
			},
			{
				title: 'Approvisionnements',
				icon: '$livraisons',
				grant: 'NAV_APPROVISIONNEMENT',
				children: [
					{
						route: { name: 'approvisionnements' },
						title: 'Liste des approvisionnement',
						icon: '$list_ventes',
						grant: 'API_GET_APPROVISIONNEMENT',
					},
					{
						title: 'Créer un approvisionnement',
						icon: '$new_ventes',
						grant: 'API_POST_APPROVISIONNEMENT',
						clickparameter: 'Approvisionnement',
					},
				]
			},
			{
				title: 'Commande',
				icon: '$box',
				grant: 'NAV_COMMANDE',
				children: [
					{
						route: { name: 'commandes' },
						title: 'Commandes en cours',
						icon: '$list_ventes',
						grant: 'API_GET_COMMANDE',
					},
					{
						route: { name: 'historique-commandes' },
						title: 'Historique des commandes',
						icon: '$list_ventes',
						grant: 'API_GET_COMMANDE',
					},
					{
						title: 'Créer une commande',
						icon: '$new_ventes',
						grant: 'API_POST_COMMANDE',
						clickparameter: 'Commande',
					},
				]
			},
			{
				title: 'Expéditions',
				icon: '$ventes',
				grant: 'NAV_VENTES',
				children: [
					{
						route: { name: 'ventes' },
						title: 'Liste des expéditions',
						icon: '$list_ventes',
						grant: 'API_GET_VENTE',
					},
					{
						title: 'Créer une expédition',
						icon: '$new_ventes',
						grant: 'API_POST_VENTE',
						clickparameter: 'Vente',
					},
				]
			},
			{
				title: 'Paramétrage',
				icon: '$settings',
				grant: 'NAV_PARAMETRES',
				children: [
					{
						route: { name: 'essences' },
						title: 'Liste des essences',
						icon: '$essences',
						grant: 'API_GET_ESSENCES',
					},
					{
						route: { name: 'longueursAchat' },
						title: 'Longueurs d\'achat',
						icon: '$list_longueurs',
						grant: 'API_GET_LONGUEURSACHAT',
					},
					{
						route: { name: 'longueursVente' },
						title: 'Longueurs de vente',
						icon: '$list_longueurs',
						grant: 'API_GET_LONGUEURSVENTE',
					},
					{
						route: { name: 'transporteurs' },
						title: 'Liste des transporteurs',
						icon: '$transports',
						grant: 'API_GET_TRANSPORTS',
					},
					{
						route: { name: 'pile' },
						title: 'Liste des piles',
						icon: '$piles',
						grant: 'API_GET_PILE',
					},
					{
						route: { name: 'user' },
						title: 'Liste des utilisateurs',
						icon: '$user',
						grant: 'API_GET_USER',
					},
					/*{
						route: { name: 'token' },
						title: 'API Tokens',
						icon: 'mdi-key-variant',
					},*/
				]
			},
		];

		private onOpen() {
			this.open = true;
			this.reduce = false;
		}

		private onReduce() {
			if (this.open) {
				this.open = false;
			} else {
				this.reduce = true;
			}
		}

		private appVersion = version;

		private editFournisseur: Fournisseur = null;
		private editClient: Client = null;
		private editVente: Vente = null;
		private editAchat: Achat = null;
		private editApprovisionnement: Approvisionnement = null;
		private editCommande: Commande = null;
		private editLivraison: boolean = null;

		@Emit()
		private onCreate($parameter): void {
			switch ($parameter) {
  				case 'Fournisseur':
					this.editFournisseur = new Fournisseur();
    			break;
				case 'Client':
					this.editClient = new Client();
				break;
				case 'Vente':
					this.editVente = new Vente();
				break;
				case 'Achat':
					this.editAchat = new Achat();
				break;
				case 'Approvisionnement':
					this.editApprovisionnement = new Approvisionnement();
				break;
				case 'Commande':
					this.editCommande = new Commande();
				break;
				case 'Livraison':
					this.editLivraison = true;
				break;
			}
		}

		private async refreshFournisseur(): Promise<void> {
			storeFournisseur.dispatch('getC', { filters: true });
		}

		private async refreshClient(): Promise<void> {
			storeClient.dispatch('getC', { filters: true });
		}

	}
